export const MuiPagination = {
    MuiPagination: {
        defaultProps: {
            color: 'primary',
        },
    },
};
